var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorteLogoUqai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Textures/corte-footer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 5660",
    d: "M0 40C0.375989 40 0.751979 39.9001 1.0686 39.7001L33.3641 20.5297C40.5673 16.2519 45 8.45577 45 0V19.99V39.98H0V40Z",
    fill: "#A00000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorteLogoUqai);
export default __webpack_public_path__ + "static/media/corte-logo-uqai.1ff55b94.svg";
export { ForwardRef as ReactComponent };